import {
  StyledJobOfferSubsection,
  StyledJobOfferSubsectionTitle,
} from './JobOfferSubsection.styled';

const JobOfferSubsection = ({ children, title }) => (
  <StyledJobOfferSubsection>
    <StyledJobOfferSubsectionTitle editorial>{title}</StyledJobOfferSubsectionTitle>
    {children}
  </StyledJobOfferSubsection>
);

export default JobOfferSubsection;
